import React from "react";
import {useAppSelector} from "../DAL/store";

/**
 * Top page details
 */
interface ISelectedProductImgProps {
    relativePath:string
}
const SelectedProductImg = (props:ISelectedProductImgProps) => {
    const ImageCDNDomain = useAppSelector((store) => store.ImageCDNDomain);

    return (
        <>
            {props.relativePath && props.relativePath.length > 0 &&
                    <div className="w-full bg-gray-100 p-2 flex items-center justify-center mt-4">
                        <img  src={ImageCDNDomain + props.relativePath} alt="product" />
                    </div>
            }
        </>
    );
};

export default SelectedProductImg;
